export default function IMEIBasedSuccessRateTableHeaderPropView() {

  function createDayPropsThTags(weeks = {}) {
    const dayPropsThTags = [];

    for (let w in weeks) {
      const daysASC = Object.keys(weeks[w]).sort((a, b) => a.localeCompare(b));
      dayPropsThTags.push(
        ...[...daysASC, "Total"].map(() => [
          m("th[colspan=1]", "Total"),
          m("th[colspan=1]", "Success"),
          m("th[colspan=1]", "Fail"),
          m("th[colspan=1]", "Success Rate (%)"),
        ])
      );
    }

    return m("tr.text-center.align-middle", dayPropsThTags);
  }
  return {
    view: (vnode) => {
      return createDayPropsThTags(vnode.attrs.weeks)
    }
  }
}